<!--
  Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<p-card header="You currently don't have access to eSCI Tools">
  <div>
    <ul>
      <li>To request access, please go to <a href = "https://glenda.gm.com/" target="_blank">glenda.gm.com</a>. Search for “<b>eSCI</b>” and in the search results, select the appropriate role</li>
    </ul>
  </div>
</p-card>
